import { useDispatch } from 'react-redux';
import { FieldValues } from 'react-hook-form';
import { useEffect, useRef, useState } from 'react';

import { showLoader, hideLoader } from '../../store/slices/generalSlice';

interface IUseResumeData {
  valuesToFetch: Promise<FieldValues | undefined>[];
  fetch: boolean;
}

const useResumeData = (props: IUseResumeData) => {
  const { fetch, valuesToFetch } = props;
  const [savedData, setSavedData] = useState<(FieldValues | undefined)[]>();
  const shouldComponentUpdate = useRef<boolean>(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (fetch && shouldComponentUpdate.current) {
      const getResumeData = async () => {
        dispatch(showLoader({ action: 'getResumeData' }));
        const data = await Promise.all([...valuesToFetch]);
        setSavedData(data);
        dispatch(hideLoader({ action: 'getResumeData' }));
      };
      void getResumeData();
      shouldComponentUpdate.current = false;
    }
  }, [dispatch, fetch, valuesToFetch]);

  useEffect(() => {
    if (fetch === false) {
      shouldComponentUpdate.current = true;
    }
  }, [fetch]);

  return { savedData };
};

export default useResumeData;
